import React from 'react';
import { View, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

export const RoundedBorderIcon = ({ children, size = 35, customStyle }) => {
  return (
    <View style={[styles.container, {
      width: defaultScale(size),
      height: defaultScale(size),
      borderRadius: defaultScale(size / 2),
    }, customStyle]}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Theme.GREY,
    justifyContent: 'center',
  },
});
